import { Link } from 'react-router-dom';
import SectionHeading from '@/components/feature/SectionHeading';
import { trendingList } from '@/mocks/trending';

const trendIcon: Record<string, { icon: string; cls: string; label: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-600', label: '上升' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-secondary-600', label: '回落' },
  steady: { icon: 'ri-subtract-line', cls: 'text-foreground-400', label: '持平' },
  new: { icon: 'ri-flashlight-fill', cls: 'text-accent-600', label: '新上榜' },
};

export default function TrendingBoard() {
  const list = trendingList.slice(0, 10);

  return (
    <section id="ranking" className="w-full bg-background-100 border-y border-background-200">
      <div className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <SectionHeading
          eyebrow="今日热搜盘点"
          title="此刻讨论量最高的十条热点"
          description="按公开平台的讨论量、转发与评论综合排序，热度值只代表相对高低，不构成任何事实判断。"
          extra={
            <Link
              to="/ranking"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-foreground-950 text-sm text-foreground-950 hover:bg-foreground-950 hover:text-background-50 transition-colors whitespace-nowrap"
            >
              查看完整榜单
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          }
        />

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-1">
          {list.map((item) => {
            const trend = trendIcon[item.trend];
            return (
              <Link
                key={item.rank}
                to={item.articleId ? `/article/${item.articleId}` : '/ranking'}
                className="group flex items-center gap-4 py-4 border-b border-background-300/70"
              >
                <span
                  className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center font-heading text-base font-bold ${
                    item.rank <= 3
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-50 text-foreground-500 border border-background-300'
                  }`}
                >
                  {item.rank}
                </span>
                <span className="flex-1 min-w-0">
                  <span className="block text-sm md:text-[15px] text-foreground-900 group-hover:text-primary-700 transition-colors truncate">
                    {item.title}
                  </span>
                  <span className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
                    <span className="px-1.5 py-0.5 rounded bg-background-50 border border-background-200">
                      {item.category}
                    </span>
                    <span className={`flex items-center gap-0.5 ${trend.cls}`}>
                      <i className={trend.icon} aria-hidden="true"></i>
                      {trend.label}
                    </span>
                  </span>
                </span>
                <span className="shrink-0 text-right">
                  <span className="block text-sm font-semibold text-primary-600">
                    {item.heat.toLocaleString()}
                  </span>
                  <span className="text-[11px] text-foreground-400">热度值</span>
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}